export default __webpack_public_path__ + "static/media/bitbucket.cd87aa02.svg";